var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_video_room_wrp jitsi_video_for_confreness_wrp"},[_c('div',{staticClass:"zisti_video_box",attrs:{"id":"jitsi-meet-conf-container"}})])
}]

export { render, staticRenderFns }